/* eslint-disable no-console */

import { register } from "register-service-worker";

// Bridge so a Vue component can react to "update available"
type UpdateHandler = (waiting: ServiceWorker | null) => void;
let onUpdate: UpdateHandler | null = null;
export function onUpdateAvailable(handler: UpdateHandler): void {
  onUpdate = handler;
}

if (process.env.NODE_ENV === "production") {
  // Once the waiting worker takes control (after SKIP_WAITING), reload once so
  // the page runs the freshly-deployed assets.
  let refreshing = false;
  navigator.serviceWorker?.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered(registration) {
      console.log("Service worker has been registered.");
      // Poll for a new deploy so the update toast can appear even while the tab
      // sits idle, not only on the next navigation.
      setInterval(() => registration.update(), 60 * 1000);
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available; please refresh.");
      onUpdate?.(registration.waiting);
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
